/**
 * Copyright 2016-2026, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const LOG_LEVEL = {
    NOTSET: 0,
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4,
};
export const CONTROL_ATTRIBUTES = {
    BOT_FILTERING: '$opt_bot_filtering',
    BUCKETING_ID: '$opt_bucketing_id',
    STICKY_BUCKETING_KEY: '$opt_experiment_bucket_map',
    USER_AGENT: '$opt_user_agent',
};
export const JAVASCRIPT_CLIENT_ENGINE = 'javascript-sdk';
export const NODE_CLIENT_ENGINE = 'node-sdk';
export const REACT_NATIVE_JS_CLIENT_ENGINE = 'react-native-js-sdk';
export const CLIENT_VERSION = '6.5.0';
/*
 * Represents the source of a decision for feature management. When a feature
 * is accessed through isFeatureEnabled or getVariableValue APIs, the decision
 * source is used to decide whether to dispatch an impression event to
 * Optimizely.
 */
export const DECISION_SOURCES = {
    FEATURE_TEST: 'feature-test',
    ROLLOUT: 'rollout',
    EXPERIMENT: 'experiment',
    HOLDOUT: 'holdout',
};
export const EXPERIMENT_TYPES = {
    AB: 'ab',
    MAB: 'mab',
    CMAB: 'cmab',
    TD: 'td',
    FR: 'fr',
};
export const AUDIENCE_EVALUATION_TYPES = {
    RULE: 'rule',
    EXPERIMENT: 'experiment',
};
/*
 * Possible types of variables attached to features
 */
export const FEATURE_VARIABLE_TYPES = {
    BOOLEAN: 'boolean',
    DOUBLE: 'double',
    INTEGER: 'integer',
    STRING: 'string',
    JSON: 'json',
};
/*
 * Supported datafile versions
 */
export const DATAFILE_VERSIONS = {
    V2: '2',
    V3: '3',
    V4: '4',
};
export const DECISION_MESSAGES = {
    SDK_NOT_READY: 'Optimizely SDK not configured properly yet.',
    FLAG_KEY_INVALID: 'No flag was found for key "%s".',
    VARIABLE_VALUE_INVALID: 'Variable value for key "%s" is invalid or wrong type.',
};
/**
 * Default milliseconds before request timeout
 */
export const REQUEST_TIMEOUT_MS = 60 * 1000; // 1 minute
export const DEFAULT_CMAB_CACHE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
export const DEFAULT_CMAB_CACHE_SIZE = 10000;
export const DEFAULT_CMAB_RETRIES = 1;
export const DEFAULT_CMAB_BACKOFF_MS = 100; // 100 milliseconds
export const __platforms = ['__universal__'];
//# sourceMappingURL=index.js.map